import React, { useEffect, useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import swal from "sweetalert";
import AES from "crypto-js/aes";
import { enc } from "crypto-js";
import { BASE_URL } from "../CommonApi";

const UpdateUnits = ({ handleCancel, unitId }) => {
  const jwtToken = localStorage.getItem("jwtToken");
  const encryptedUniqueId = localStorage.getItem("uniqueId1");
  const decryptedUniqueId = AES.decrypt(
    encryptedUniqueId,
    "1234567812345678"
  ).toString(enc.Utf8);

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    uniqueId: decryptedUniqueId || "",
    unitName: "",
    description: "",
  });

  useEffect(() => {
    fetch(`${BASE_URL}/fetchItemUnitById`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ id: unitId, uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Unit Data fetched:", data);
        if (data.responseMessage) {
          const unitData = data.responseMessage;
          setFormData({
            unitName: unitData.unitName || "",
            description: unitData.description || "",
          });
        } else {
          console.error("Error fetching Unit data:", data.message);
          swal({
            icon: "error",
            title: "Failed to fetch Unit details",
            text: data.message || "An error occurred",
          });
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
        swal({
          icon: "error",
          title: "An Error Occurred",
          text: "Failed to fetch Unit details",
        });
      });
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdateUnit = async (e) => {
    e.preventDefault();

    const updatedUnitData = {
      id: unitId,
      uniqueId: decryptedUniqueId,
      unitName: formData.unitName,
      description: formData.description,
    };
    setLoading(true);

    try {
      const response = await fetch(`${BASE_URL}/updateItemunit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify(updatedUnitData),
      });

      const data = await response.json();

      if (data.status === "success") {
        swal({
          icon: "success",
          title: "Success",
          text: "Unit updated successfully",
        }).then(() => {
          handleCancel();
        });
      } else {
        throw new Error(data.message || "Failed to update Unit");
      }
    } catch (error) {
      console.error("Error updating Unit:", error);
      swal({
        icon: "error",
        title: "Error",
        text: error.message || "An error occurred while updating the Unit",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancelClick = () => {
    const confirmCancel = window.confirm(
      "Are you sure you want to leave this page? Any unsaved changes will be lost."
    );
    if (confirmCancel) {
      handleCancel();
    }
  };

  if (loading) {
    return (
      <div className="container-fluid">
        <div className="page-content">
          <div className="center-div">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="my-3">
        <div className="d-flex align-items-center ml-1 mt-4">
          <div
            className="cursor-pointer d-flex justify-content-center align-items-center"
            style={{
              backgroundColor: "white",
              borderRadius: "50%",
              height: "35px",
              width: "38px",
            }}
          >
            <ArrowBackIosIcon
              className="arrow-child"
              onClick={handleCancelClick}
            />
          </div>
          <div className="newcustomer-head ml-2">
            <h5 className="ml-1 mb-0" style={{ color: "#086bd5de" }}>
              Update Unit
            </h5>
          </div>
        </div>
      </div>

      <Container fluid>
        <Card className="card-style p-4">
          <Row>
            <Col md="3">
              <Form.Group>
                <label className="text-primary" style={{ fontWeight: "600" }}>
                  Unit Details
                </label>
              </Form.Group>
            </Col>
          </Row>

          <Form onSubmit={handleUpdateUnit}>
            <Row>
              {/* From Name */}
              <Col md="6">
                <Form.Group>
                  <label style={{ color: "grey" }}>Unit Name</label>
                  <Form.Control
                    placeholder="Enter Unit Name"
                    name="unitName"
                    value={formData.unitName}
                    onChange={handleInputChange}
                    style={{ backgroundColor: "#F6F6F6", height: "40px" }}
                  />
                </Form.Group>
              </Col>

              {/* Tracking Number */}
              <Col md="6">
                <Form.Group>
                  <label style={{ color: "grey" }}>Unit Description</label>
                  <Form.Control
                    placeholder="Enter Unit Description"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    style={{ backgroundColor: "#F6F6F6", height: "40px" }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <hr className="mt-4" />

            <div className="text-right invoice-bottombtns">
              <Button
                variant="secondary"
                className="mt-0 mr-2"
                onClick={handleCancelClick}
              >
                Cancel
              </Button>
              <Button type="submit" variant="primary">
                Update Unit
              </Button>
            </div>
          </Form>
        </Card>
      </Container>
    </div>
  );
};

export default UpdateUnits;
